"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = void 0;
exports.content = {
  en: {
    validation: {
      required: "Required",
      atLeastOne: "At least one is required"
    }
  },
  fr: {
    validation: {
      required: "Obligatoire",
      atLeastOne: "Au moins une case à cocher est requise"
    }
  },
  es: {
    validation: {
      required: "Requerido",
      atLeastOne: "Se requiere al menos una casilla de verificación"
    }
  }
};